<template>


  <div class="vx-row w-full event-details m-0 text-left scroll-area_ mh-80">
    <h5 class="pb-2 w-full">Bilgiler</h5>
    <div class="control-wrapper vx-col px-1 pb-2">
      <div class=" vx-row flex flex-wrap m-0">
        <div class="vx-col w-1/2">
          <div class="control-title">Bölge :</div>
          <div class="control-value">{{getEventPropString(data_map.bolge.name) }}</div>
        </div>
        <div class="vx-col w-1/2">
          <div class="control-title">İşletme :</div>
          <div class="control-value">{{getEventPropString(data_map.isletme.name)}}</div>
        </div>
        <div class="vx-col w-1/2">
          <div class="control-title">Kule Adı :</div>
          <div class="control-value">{{getEventPropString(data_map.kule.name)}}</div>
        </div>
        <div class="vx-col w-1/2">
          <div class="control-title">Şeflik Adı :</div>
          <div class="control-value">{{getEventPropString(data_map.seflik.name)}}</div>
        </div>

        <div class="vx-col w-1/2">
          <div class="control-title">Sıcaklık :</div>
          <div class="control-value">{{getEventPropString(event.sicaklik)}} °C</div>
        </div>
        <div class="vx-col w-1/2">
          <div class="control-title">Nem :</div>
          <div class="control-value">{{getEventPropString(event.nem)}}%</div>
        </div>
        <div class="vx-col w-1/2">
          <div class="control-title">Rüzgar Yönü :</div>
          <div class="control-value">{{getEventPropString(event.ruzgar_acisi)}}° {{getEventPropString(event.ruzgar_yonu)}}</div>
        </div>
        <div class="vx-col w-1/2">
          <div class="control-title">Rüzgar Hızı : </div>
          <div class="control-value">{{getEventPropString(parseFloat(event.ruzgar_hizi) * 3.6).toFixed(2).toString()}} km/s</div>
        </div>

        <div class="vx-col w-full">
          <div class="control-title">Yangın Koordinatı :</div>
          <div class="control-value">{{getEventCoordString(event.yangin_koordinati)}}</div>
        </div>
        <div class="vx-col w-1/2">
          <div class="control-title">Yangın Rakımı :</div>
          <div class="control-value">{{getEventPropString(event.yangin_rakimi)}} m</div>
        </div>
        <div class="vx-col w-1/2">
          <div class="control-title">Yangın Uzaklığı :</div>
          <div class="control-value">{{getEventPropString(event.yangin_uzakligi)}} m</div>
        </div>
      </div>
    </div>

    <h5 class="pb-2 w-full">İşlemler</h5>
    <div class="vx-col flex flex-col" v-if="showislems">
      <vx-card class="p-0 mb-2" no-radius v-for="(item, index) in eventDetail.logs" :key="index">
        <div class="vx-row w-full p-0 flex m-0">
          <div class="vx-col w-1/5 text-left">
            <feather-icon v-if="item.status === 'None'" icon="EyeIcon" svgClasses="w-4 h-4 hover:text-secondary stroke-current"  />
            <feather-icon v-if="item.status === '0'" icon="AlertOctagonIcon"  class="yangin" svgClasses="w-4 h-4 hover:text-secondary stroke-current"  />
            <feather-icon v-if="item.status === '1'" icon="XIcon"  class="yangin-degil" svgClasses=" w-4 h-4 hover:text-secondary stroke-current" />
            <feather-icon v-if="item.status === '2'" icon="FlagIcon" class="yangin-kontrol" svgClasses=" w-4 h-4 hover:text-secondary stroke-current" />
            <feather-icon v-if="item.status === '3'" icon="HexagonIcon" class="sogutma" svgClasses="w-4 h-4 hover:text-secondary stroke-current" />
            <feather-icon v-if="item.status === '4'" icon="CheckIcon"  class="yangin-sondu-in" svgClasses="w-4 h-4 hover:text-secondary stroke-current" />
          </div>
          <div class="log-wrapper vx-col w-4/5 p-0 text-sm">
            <div class="status-text">{{getStatusText(item.status)}}</div>
          </div>
          <div class="status-info vx-row w-full p-0 m-0">
            <div class="status-user vx-col w-1/3 p-0 text-left"> <small>{{item.user.username}} </small></div>
            <div class="status-date vx-col w-2/3 p-0 text-right mr-0"><small>{{ item.description }}</small> </div>
          </div>
        </div>


      </vx-card>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'EventDetails',
  components: {
  },
  props: {
    data_map: {
      type: Object
    },
    event: {
      type: Object
    }
  },
  data () {
    return {
      showislems: false
    }
  },
  mounted () {
    this.getEventDetails()
  },
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    eventDetail () {
      return this.eventDetailList[this.event.id]
    },
    eventDetailList () {
      return this.$store.state.event_detail
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.event_data.length
    }
  },
  watch: {
    event () {
      this.getEventDetails()
    }
  },
  methods: {
    formatDate (value) {
      if (value) {
        return moment(String(value), 'DD-MM-YYYY hh:mm:ss').format('MM/DD/YYYY hh:mm')
      }
    },
    convertUTCDateToLocalDate (date) {
      const date_ = new Date(date.concat(' UTC'))
      console.log('converting str', date)
      console.log('converting date', date_)
      date_.setMinutes(date_.getMinutes() - date_.getTimezoneOffset())
      return date_
    },
    getStatusText (status) {
      switch (status) {
      case 'None':
        return 'Duman algılandı'

      case '0':
        return 'Orman Yangını'

      case '1':
        return 'Yangın değil'

      case '2':
        return 'Kontrol altında'

      case '3':
        return 'Zirai Yangın'

      case '4':
        return 'Söndürüldü'
      }
    },

    getEventDetails () {
      //this.$vs.loading()
      const payload = {
        id: this.event.id
      }

      this.$store.dispatch('getEventDetails', payload)
        .then((response) => {
          console.log('event details', response)
          console.log('event details response', this.$store.state.event_detail)
          setTimeout(() => {
            this.showislems = true
            console.log('event details list', this.eventDetailList)
            console.log('event details list', this.eventDetail)
          }, 500)
          //this.$vs.loading.close()
        })
        .catch(error => {
          //this.$vs.loading.close()
          console.log('error', error)
        })
    },
    ConvertDDToDMS (D) {
      const result = [0 | D, '° ', 0 | (D < 0 ? D =  -D : D) % 1 * 60, '\' ', 0 | D * 60 % 1 * 60, '" '].join('')
      return result
    },
    getEventCoordString (coords) {
      if (coords === '') {
        return '-'
      } else {
        const lat = coords.split(' ')[0]
        const longti = coords.split(' ')[1]

        const latDMS = this.ConvertDDToDMS(lat)
        const lonDMS = this.ConvertDDToDMS(longti)

        return  `${latDMS} ${lonDMS}`
      }
    },
    getEventPropString (string) {
      if (string === '' || string === '0') {
        return '-'
      } else {
        return string
      }
    },

    setEventMap (event) {
      const location = {
        lat: parseFloat(event.kule_koordinati.split(' ')[0]),
        lng: parseFloat(event.kule_koordinati.split(' ')[1])
      }

      if (event.yangin_koordinati !== '') {
        const location_yangin = {
          lat: parseFloat(event.yangin_koordinati.split(' ')[0]),
          lng: parseFloat(event.yangin_koordinati.split(' ')[1])
        }
        this.defaultMapOptions.yangin = location_yangin

      }
      console.log(location)
      this.defaultMapOptions.center = location
      this.selectedEvent = event
    },
    getRowColor (status) {
      return {
        'yangin'   : status === '0',
        'yangin-degil'   : status === '1',
        'yangin-kontrol'   : status === '2',
        'yangin-sondu' : status === '3'
      }
    },

    getFireIconColor (status) {
      let return_image = null
      switch (status) {
      case 'None':
        return_image = require('@/assets/images/arf/50x50_gri.png')
        break
      case '0':
        return_image = require('@/assets/images/arf/50x50_kirmizi.png')
        break
      case '1':
        return_image = require('@/assets/images/arf/50x50_gri.png')
        break
      case '2':
        return_image = require('@/assets/images/arf/50x50_turuncu.png')
        break
      case '3':
        return_image = require('@/assets/images/arf/50x50_yesil.png')
        break
      case '4':
        return_image = require('@/assets/images/arf/50x50_gri.png')
        break


      }

      return return_image
    },
    generalView () {

      this.viewPortBorders.map((item) => {
        this.bounds.extend(item)
      })

      this.selectedMarker = { event: {event_image: ''} }
      this.map.fitBounds(this.bounds)
    }
  }
}
</script>
<style lang="scss">
.event-details {
  .vx-card__body {
    padding: 10px !important;
  }
  .control-wrapper {
    .vx-col {
      font-size: 12px;
    }
  }
}

.mh-80 {
  max-height: 67.5vh;
  overflow-y: auto;
}
.event-details {
  h5 {
    color: #f0f0f0;
  }
}
.scroll-area_::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px #f7f7f7;
  border-radius: 10px;
  background-color: #f7f7f7;
}

.scroll-area_::-webkit-scrollbar
{
  width: 3px;
  height: 3px;
  background-color: #f7f7f7;
}

.scroll-area_::-webkit-scrollbar-thumb
{
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px #9c9c9c;
  background-color: #f2f2f2;
}

.author_name {
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
}
.control-wrapper {
  .vx-col {
    margin-bottom: 5px;
  }
  .vx-col {
    background: #182625;
  }
}
.control-title {
}
.control-value {
  font-weight: bold;

}
</style>
